var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "thread-message",
      class: { expanded: _vm.isExpanded, collapsed: !_vm.isExpanded },
    },
    [
      _c("div", { staticClass: "mail-meta", on: { click: _vm.toggleExpand } }, [
        _c("div", { staticClass: "sender-info" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sender-details" }, [
            _c("div", { staticClass: "sender-row" }, [
              _c("div", { staticClass: "sender-name" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.getSenderName(_vm.mail.sender)) +
                    "\n                        "
                ),
                _c("span", { staticClass: "sender-email" }, [
                  _vm._v("<" + _vm._s(_vm.mail.sender) + ">"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "recipient" },
              [
                _c("span", { staticClass: "label" }, [_vm._v("Alıcı:")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "value" },
                  _vm._l(_vm.mail.to_list, function (m) {
                    return _c(
                      "span",
                      {
                        key: m,
                        class: {
                          "mail-link":
                            m ===
                            (_vm.mail.ref_visitor_id &&
                              _vm.mail.ref_visitor_id.email),
                        },
                        on: {
                          click: function ($event) {
                            m ===
                              (_vm.mail.ref_visitor_id &&
                                _vm.mail.ref_visitor_id.email) &&
                              _vm.openContactProfile()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(m) +
                            "\n                            "
                        ),
                        !_vm.isLastToListEmail(m)
                          ? _c("span", [_vm._v(",")])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      placement: "bottom",
                      trigger: "hover",
                      overlayStyle: { maxWidth: "400px" },
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "mail-details-popover" }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("div", { staticClass: "detail-label" }, [
                                  _vm._v(_vm._s(_vm.$t("message.subject"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail-value" }, [
                                  _vm._v(_vm._s(_vm.mail.subject)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-item" }, [
                                _c("div", { staticClass: "detail-label" }, [
                                  _vm._v(_vm._s(_vm.$t("mail.From")) + ":"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail-value" }, [
                                  _vm._v(_vm._s(_vm.mail.sender)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-item" }, [
                                _c("div", { staticClass: "detail-label" }, [
                                  _vm._v(_vm._s(_vm.$t("mail.To")) + ":"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail-value" }, [
                                  _vm._v(_vm._s(_vm.mail.to_list.join(", "))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.mail.cc_list && _vm.mail.cc_list.length > 0
                                ? _c("div", { staticClass: "detail-item" }, [
                                    _c("div", { staticClass: "detail-label" }, [
                                      _vm._v("CC:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "detail-value" }, [
                                      _vm._v(
                                        _vm._s(_vm.mail.cc_list.join(", "))
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mail.bcc_list && _vm.mail.bcc_list.length > 0
                                ? _c("div", { staticClass: "detail-item" }, [
                                    _c("div", { staticClass: "detail-label" }, [
                                      _vm._v("BCC:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "detail-value" }, [
                                      _vm._v(
                                        _vm._s(_vm.mail.bcc_list.join(", "))
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail-item" }, [
                                _c("div", { staticClass: "detail-label" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("chatbotv2.date")) + ":"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(_vm.mail.created_at))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "i",
                      { staticClass: "material-icons mail-detail-toggle" },
                      [_vm._v("keyboard_arrow_down")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.threadShowsComposeForm
          ? _c("div", { staticClass: "mail-date-only" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.formatDate(_vm.mail.created_at)) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.threadShowsComposeForm
          ? _c(
              "div",
              {
                staticClass: "mail-actions",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "mail-date" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.mail.created_at))),
                ]),
                _vm._v(" "),
                _c(
                  "a-dropdown",
                  {
                    attrs: {
                      trigger: ["click"],
                      overlayClassName: "custom-mail-dropdown",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                [
                                  _c(
                                    "a-menu-item",
                                    {
                                      key: "ai-sentiment",
                                      staticClass: "ai-menu-item",
                                      on: {
                                        click: _vm.handleSentimentAnalysis,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ai-tool-menu-item" },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("psychology")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mail.mailAiAssistant.aiSentimentAnalysis"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu-item",
                                    {
                                      key: "ai-summary",
                                      staticClass: "ai-menu-item",
                                      on: { click: _vm.handleSummarize },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ai-tool-menu-item" },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("summarize")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mail.mailAiAssistant.aiCreateSummarized"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a-menu-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu-item",
                                    {
                                      key: "reply",
                                      on: { click: _vm.handleReply },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("reply")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("mail.reply"))),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasMultipleRecipients
                                    ? _c(
                                        "a-menu-item",
                                        {
                                          key: "replyAll",
                                          on: { click: _vm.handleReplyAll },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("reply_all")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("mail.replyAll"))
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu-item",
                                    {
                                      key: "forward",
                                      on: { click: _vm.handleForward },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("forward")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.forwardRep"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a-menu-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu-item",
                                    {
                                      key: "delete",
                                      attrs: { danger: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("delete", _vm.mail)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("delete")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.delete"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1991471781
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "action-button",
                        attrs: { title: _vm.$t("message.greaterThan") },
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            style: { color: "#22272d" },
                          },
                          [_vm._v("more_vert")]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isExpanded
        ? _c(
            "div",
            { staticClass: "mail-content" },
            [
              _c("div", { staticClass: "mail-content-container" }, [
                _c("iframe", {
                  ref: "mailContentIframe",
                  staticClass: "mail-content-iframe",
                  attrs: {
                    frameborder: "0",
                    sandbox:
                      "allow-same-origin allow-popups allow-popups-to-escape-sandbox",
                  },
                  on: { load: _vm.adjustIframeHeight },
                }),
              ]),
              _vm._v(" "),
              _vm.mail.attachments && _vm.mail.attachments.length > 0
                ? _c("attachment-list", {
                    attrs: { attachments: _vm.mail.attachments },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAIAssistant
        ? _c("MailAIAssistant", {
            attrs: {
              mode: _vm.aiAssistantMode,
              autoRun: true,
              useCloseButton: true,
              mailContent: _vm.mailBodyContent,
              threadMails: [_vm.mail],
            },
            on: {
              close: function ($event) {
                _vm.showAIAssistant = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sender-avatar" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("account_circle")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }